
export default ['MM/DD/YYYY', 'DD/MM/YYYY', 'DD. MM. YYYY', 'MM. DD. YYYY']